<template>
  <div id="smartTown">
    <p class="page-notice">提示：本页内容为疫情防控时期的产品方案存档，相关业务请以现行政策与最新产品方案为准。</p>
    <div class="flex">
      <img
        src="@/assets/images/pic200-16.png"
        style="width: 100%;max-width:561px;"
        alt=""
      />
    </div>
      <div class="text">
该产品以数据协同为抓手，通过自定义防控任务流转引擎、自定义核酸检查计划引擎的技术核心，充分利用信息通信技术及互联网平台，推行“互联网+常态化核酸检测”信息化管理新模式，提高核酸检测效率和精细化管理水平。结合指挥人员与防控工作人员的具体工作与需求，通过数据能力实现科学防控的目标，同时应用于被管控人员管理，缓解因隔离服务工作不到位产生的社会矛盾。      </div>
  </div>
</template>
<script>
export default {
  name: "smartTown",
  data() {
    return {};
  },
};
</script>
<style scoped>
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.page-notice{background:#FFF7E6;border:1px solid #FFE0A3;color:#8A5A00;font-size:14px;padding:10px 16px;border-radius:4px;margin-bottom:20px;}
.text{
    line-height: 24px;
  font-weight: 500;
    color: #666;
    margin-top: 30px;
    margin-right: 20px;
    text-indent: 28px
}
</style>




// WEBPACK FOOTER //
// src/view/software7.vue